var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:this.winWidth>1000?'home':'widths'},[_c('header-content'),_c('nav-head'),_c('div',{staticClass:"content"},[_c('router-view',{key:_vm.$route.fullPath})],1),_c('footer-content')],1)}
var staticRenderFns = []

export { render, staticRenderFns }